import React, { useEffect, useMemo, useRef, useState } from "react";

import "react-18-image-lightbox/style.css";
import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";
import { useAppSelector } from "../../hooks/hooks";
import ResponsiveModalAbsolute from "../../components/ResponsiveModalAbsolute";

import { formatearNumero } from "../../components/helpers/formatearNumero";
import { usePriceToSelectedCurrency } from "../../hooks/usePriceToSelectedCurrency";

import Spinner from "../../components/helpers/Spinner";
import Swal from "sweetalert2";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Lazy } from "swiper";
import "swiper/css/lazy";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Calendar from "react-calendar";

import getEveryDayBetween2Dates from "../../helpers/getEveryDayBetween2Dates";
import { getEachDayPrice } from "../../helpers/getEachDayPrice";
import { transformDatesToSlash } from "../../helpers/transformDatesToSlash";
import useCurrencyPrices from "../../hooks/useCurrencyPrices";

import { ModalCupon } from "./ModalCupon";

import { useNavigate } from "react-router-dom";
import {
    DiaDisponible,
    FechaDisponible,
    huespedesProps,
    ListadoFecha,
    Props,
    reserva,
    Reservas,
    Tour,
} from "../../components/helpers/types/modal_tour";
import ModalHuespedes from "../../components/helpers/ModalHuespedes";

export const ModalTour = ({
    modalVisible,
    setModalVisible,
    id_tour,
    fecha_ingreso,
    total_huespedes,
}: Props) => {
    const navigate = useNavigate();

    const [modalCalendar, setModalCalendar] = useState<boolean>(false);
    const [modalHuespedes, setModalHuespedes] = useState<boolean>(false);
    const [reserveVisible, setReserveVisible] = useState<boolean>(false);
    const [allDatesSelected, setAllDatesSelected] = useState<Date[]>([]);
    const [errorReserve, setErrorReserve] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [cupon, setCupon] = useState(0);
    const { SELECTED_CURRENCY } = useCurrencyPrices();
    const [reserva, setReserva] = useState<reserva>({
        precio_alquiler: 0,
        precio_total_reserva: 0,
    });

    const [listadoFechas, setListadoFechas] = useState<ListadoFecha[]>([]);
    const [cantidadFechas, setCantidadFechas] = useState(20);
    const scrollRef = useRef<HTMLDivElement>(null);

    const formatterNombre = new Intl.DateTimeFormat("es-ES", {
        weekday: "long",
        day: "numeric",
        month: "long",
    });
    const formatterISO = (fecha: Date): string => {
        const year = fecha.getFullYear();
        const month = String(fecha.getMonth() + 1).padStart(2, "0"); // getMonth es base 0
        const day = String(fecha.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const capitalizar = (texto: string) =>
        texto.charAt(0).toUpperCase() + texto.slice(1);

    // Generar fechas a partir de una fecha base
    const generarFechas = (desde: Date, cantidad: number): ListadoFecha[] => {
        const fechas: ListadoFecha[] = [];

        for (let i = 1; i <= cantidad; i++) {
            const fecha = new Date(desde);
            fecha.setDate(desde.getDate() + i);

            const nombre = capitalizar(formatterNombre.format(fecha));
            const fechaISO = formatterISO(fecha);

            fechas.push({ nombre, fecha: fechaISO });
        }

        return fechas;
    };

    useEffect(() => {
        const hoy = new Date();
        const nuevasFechas = generarFechas(hoy, cantidadFechas);
        setListadoFechas(nuevasFechas);
    }, [id_tour, cantidadFechas]);

    useEffect(() => {
        const handleScroll = () => {
            if (!scrollRef.current) return;

            if (allDatesSelected.length > 1) return;

            const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;

            // Si estamos cerca del final del scroll
            if (scrollTop + clientHeight >= scrollHeight - 100) {
                setCantidadFechas((prev) => {
                    if (prev >= 60) return prev; // máximo 60
                    return prev + 20;
                });
            }
        };

        const ref = scrollRef.current;
        if (ref) {
            ref.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (ref) {
                ref.removeEventListener("scroll", handleScroll);
            }
        };
    }, []);

    const [tour, setTour] = useState<Tour>({
        id: 0,
        nombre: "",
        descripcion: "",
        banner: "",
        precio_base: "",
        personas: "",
        plan: 2,
        id_hotel: 0,
        casa: {
            id: 0,
            nombre: "",
        },
        hotel_tour_imagenes: [],
        disponibilidades: {
            arrayDias: [],
            arrayFechas: [],
        },
        precios_variables: [],
        pedidos: {
            arrayFechasPedido: [],
        },
        horarios: [],
    });

    const modalRef = useRef<HTMLDivElement>(null);
    const modalRefCalendar = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (modalVisible) {
            getOneHabitacion();
        }
    }, [modalVisible]);

    const getOneHabitacion = async () => {
        setLoading(true);
        const response = await fetchAxiosToken({
            url: `/hoteles_tours/detalle/${id_tour}`,
            method: "get",
        });

        setTour(response);
        setLoading(false);
    };

    // Función para manejar clics fuera del modal
    const handleClickOutside = (event: MouseEvent) => {
        if (
            modalRef.current &&
            !modalRef.current.contains(event.target as Node)
        ) {
            setModalCalendar(false); // Cierra el modal
        }
    };

    const handleClickOutsideHuespedes = (event: MouseEvent) => {
        if (
            modalRefCalendar.current &&
            !modalRefCalendar.current.contains(event.target as Node)
        ) {
            setModalHuespedes(false); // Cierra el modal
        }
    };

    const [dataReseve, setDataReserve] = useState<{
        fecha_inicial: string;
        huespedes: number;
    }>({
        fecha_inicial: "Selecciona una fecha",
        huespedes: 1,
    });

    const parseDateFromString = (
        dateStr: string,
        isEndDate = false
    ): Date | null => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/").map(Number);
        if (
            !day ||
            !month ||
            !year ||
            day < 1 ||
            day > 31 ||
            month < 1 ||
            month > 12
        ) {
            console.error("Fecha inválida:", dateStr);
            return null;
        }

        const date = new Date(year, month - 1, day);

        if (isEndDate) {
            date.setHours(23, 59, 59, 999); // Establecer hora a 23:59:59.999
        }
        return date;
    };

    useEffect(() => {
        if (!loading) {
            let fecha_inicio_str = "Selecciona una fecha";

            if (fecha_ingreso !== "") {
                fecha_inicio_str = fecha_ingreso;

                let startDate: Date | null = null;

                if (fecha_ingreso) {
                    startDate = parseDateFromString(fecha_ingreso);
                }

                if (startDate) {
                    setDatesSelected({
                        fecha_inicial: startDate,
                    });

                    onChangeCalendar(startDate);
                }
            }
            setDataReserve({
                fecha_inicial: fecha_inicio_str,
                huespedes: total_huespedes,
            });
        }
    }, [loading]);

    useEffect(() => {
        // Agregar el evento cuando el modal está activo
        if (modalCalendar) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        // Eliminar el evento al desmontar o cuando el modal se cierra
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalCalendar]);

    useEffect(() => {
        // Agregar el evento cuando el modal está activo
        if (modalHuespedes) {
            document.addEventListener("mousedown", handleClickOutsideHuespedes);
        }

        // Eliminar el evento al desmontar o cuando el modal se cierra
        return () => {
            document.removeEventListener(
                "mousedown",
                handleClickOutsideHuespedes
            );
        };
    }, [modalHuespedes]);

    const [datesSelected, setDatesSelected] = useState<{
        fecha_inicial: Date;
    } | null>(null);

    const { price_to_currency } = usePriceToSelectedCurrency();

    const formatDate = (date: Date) => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Mes empieza desde 0
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const [huespedes, setHuespedes] = useState({
        adultos: 1,
        ninos: 0,
        mascotas: 0,
    });

    const onChangeCalendar = (date: Date) => {
        const fecha_inicial = formatDate(date);

        // Actualizar estados
        setDatesSelected({
            fecha_inicial: date,
        });

        setDataReserve((prev) => ({
            ...prev,
            fecha_inicial,
        }));

        const fecha = new Date(date);

        const nombre = capitalizar(formatterNombre.format(fecha));
        const fechaISO = formatterISO(fecha);

        const data_fecha = { nombre, fecha: fechaISO };

        setListadoFechas([data_fecha]);

        setModalCalendar(false);
        setReserveVisible(true);
        const all_dates_selected = getEveryDayBetween2Dates({
            array_fechas: [date],
        });

        let precioVariblePorSemana = 0;

        if (tour?.precio_base) {
            let total_alquiler = all_dates_selected.reduce(
                (acc, currentDate) => {
                    return (acc += getEachDayPrice({
                        current_day: currentDate,
                        house_variable_prices:
                            2 > 1 ? tour.precios_variables : [],
                        base_price: Number(tour.precio_base),
                    }));
                },
                0
            );

            if (all_dates_selected.length > 1) {
                all_dates_selected.pop();
            }

            setAllDatesSelected(all_dates_selected);

            /*

            const arrayFechasPedidos = infoCasa.pedidos.arrayFechasPedido.map(
                (fecha: Reservas) => {
                    const transformFecha = transformDatesToSlash({
                        date: fecha.fecha,
                    });

                    return new Date(transformFecha).getTime();
                }
            ); */

            setReserva({
                ...reserva,
                precio_alquiler:
                    precioVariblePorSemana > 0
                        ? precioVariblePorSemana
                        : total_alquiler,
            });

            let reservaFinal = price_to_currency(total_alquiler);

            setReserva({
                ...reserva,

                precio_alquiler:
                    precioVariblePorSemana > 0
                        ? precioVariblePorSemana
                        : total_alquiler,

                precio_total_reserva: reservaFinal,
            });
        }
    };

    const handleDeleteFechas = () => {
        setDataReserve((prev) => ({
            ...prev,
            fecha_inicial: "Selecciona una fecha",
        }));
        setReserveVisible(false);

        setDatesSelected(null);
        const hoy = new Date();
        const nuevasFechas = generarFechas(hoy, 20);
        setListadoFechas(nuevasFechas);
    };

    const handleModalHuespedes = () => {
        if (modalHuespedes) {
            setModalHuespedes(false); // Cierra el modal si ya está abierto
        } else {
            setModalHuespedes(true); // Abre el modal si está cerrado
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        const newValue = inputValue !== "" ? Number(inputValue) : "";

        setHuespedes((prevHuespedes) => {
            const updatedHuespedes = {
                ...prevHuespedes,
                [event.target.name]: newValue,
            };

            // Calcular el total de huéspedes
            const totalHuespedes =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            // Actualizar dataReseve con el total de huéspedes
            setDataReserve((prevData) => ({
                ...prevData,
                huespedes: totalHuespedes,
            }));

            return updatedHuespedes;
        });
    };

    useEffect(() => {
        let total_nights = allDatesSelected.length;

        if (total_nights > 0) {
            let total_alquiler = allDatesSelected.reduce((acc, currentDate) => {
                return (acc += getEachDayPrice({
                    current_day: currentDate,
                    house_variable_prices: 2 > 1 ? tour.precios_variables : [],
                    base_price: Number(tour.precio_base),
                }));
            }, 0);

            let reservaFinal = price_to_currency(total_alquiler);

            setReserva({
                ...reserva,
                precio_alquiler: total_alquiler,
                precio_total_reserva: reservaFinal,
            });
        }
    }, [dataReseve.huespedes]);

    const handleInputClick = ({ name, action }: huespedesProps) => {
        setHuespedes((prevHuespedes) => {
            const updatedHuespedes = { ...prevHuespedes };

            // Calcular el total actual de huéspedes antes de realizar cambios
            const totalHuespedesActual =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            if (action === "sumar") {
                // Solo sumar si no excede el límite
                if (totalHuespedesActual < Number(tour.personas)) {
                    switch (name) {
                        case "adultos":
                            updatedHuespedes[name] += 1;
                            break;
                        case "ninos":
                            updatedHuespedes[name] += 1;
                            break;
                        case "mascotas":
                            updatedHuespedes[name] += 1;
                            break;
                        default:
                            break;
                    }
                }
            } else {
                // Restar sin restricciones pero respetando los mínimos
                switch (name) {
                    case "adultos":
                        updatedHuespedes[name] = Math.max(
                            1,
                            updatedHuespedes[name] - 1
                        );
                        break;
                    case "ninos":
                        updatedHuespedes[name] = Math.max(
                            0,
                            updatedHuespedes[name] - 1
                        );
                        break;
                    case "mascotas":
                        updatedHuespedes[name] = Math.max(
                            0,
                            updatedHuespedes[name] - 1
                        );
                        break;
                    default:
                        break;
                }
            }

            // Calcular el nuevo total de huéspedes
            const totalHuespedes =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            setDataReserve((prevData) => ({
                ...prevData,
                huespedes: totalHuespedes,
            }));

            return updatedHuespedes;
        });
    };

    const agregarAMPM = (hora: string) => {
        const [h, m] = hora.split(":");
        const horaNum = parseInt(h, 10);
        const periodo = horaNum >= 12 ? "PM" : "AM";
        return `${h}:${m} ${periodo}`;
    };

    const handleSubmit = (horario: any, precio: string, fecha: string) => {
        const TOTAL_HUESPEDES =
            Number(huespedes.adultos) + Number(huespedes.ninos);
        if (Number(huespedes.adultos) < 1) {
            return Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Por favor primero indica la cantidad de huéspedes",
                icon: "warning",
                confirmButtonText: "Aceptar",
            });
        }
        if (TOTAL_HUESPEDES > Number(tour.personas)) {
            return Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: `Solo se permiten hasta ${tour.personas} personas incluido niños y adultos`,
                icon: "warning",
                confirmButtonText: "Aceptar",
            });
        }

        let precio_tour =
            (Number(huespedes.adultos) + Number(huespedes.ninos)) *
            Number(precio);

        localStorage.setItem(
            "reserva",
            JSON.stringify({
                id_casa: tour.id_hotel,
                precio_alquiler: price_to_currency(reserva.precio_alquiler),
                garantia: 0,
                tipo_garantia: "",

                descuento_estadia: 0,
                precio_servicios_adicionales: 0,
                precio_total: price_to_currency(
                    reserva.precio_total_reserva - cupon + precio_tour
                ),
                huespedes: {
                    adultos: Number(huespedes.adultos),
                    mascotas: Number(huespedes.mascotas),
                    ninos: Number(huespedes.ninos),
                },
                dates_selected: {
                    final_date: fecha,
                    initial_date: fecha,
                },
                servicios_adicionales: [],
                datos_alojamiento: {
                    id_habitacion: 0,
                    habitacion: "",
                    casa: tour.casa.nombre,
                    id_casa: tour.casa.id,
                    moneda: SELECTED_CURRENCY,
                },
                datos_tour: [
                    {
                        tour,
                        precio_tour_simple: price_to_currency(Number(precio)),
                        precio_tour: price_to_currency(precio_tour),
                        hora_inicio: horario.hora_inicio,
                        hora_final: horario.hora_final,
                        personas: {
                            adultos: Number(huespedes.adultos),
                            ninos: Number(huespedes.ninos),
                        },
                        fecha,
                    },
                ],
                cupon: cupon,
            })
        );

        navigate("/checkout-hotel/");
    };

    const calculateDisabledTiles = React.useMemo(
        () =>
            (date: Date): boolean => {
                if (!tour || !tour.horarios) return false;

                const fechaISO = date.toISOString().slice(0, 10);
                const diaSemana = date.getDay();

                const arrayFechas = tour.disponibilidades.arrayFechas;
                const arrayDias = tour.disponibilidades.arrayDias;

                // Verificamos si cada horario está bloqueado
                const todosBloqueados = tour.horarios.every((horario: any) => {
                    const bloqueadoPorFecha = arrayFechas.some(
                        (bloqueo: any) => {
                            return (
                                bloqueo.fecha === fechaISO &&
                                bloqueo.id_hotel_tours_horarios === horario.id
                            );
                        }
                    );

                    const bloqueadoPorDia = arrayDias.some((bloqueo: any) => {
                        const inicio = new Date(bloqueo.fecha_inicio);
                        const final = new Date(bloqueo.fecha_final);
                        return (
                            bloqueo.dia === diaSemana &&
                            bloqueo.id_hotel_tours_horarios === horario.id &&
                            date >= inicio &&
                            date <= final
                        );
                    });

                    return bloqueadoPorFecha || bloqueadoPorDia;
                });

                return todosBloqueados;
            },
        [tour]
    );

    const esFechaNoDisponible = (
        fecha: string,
        horarioId: number,
        disponibilidades: FechaDisponible[]
    ): boolean => {
        return disponibilidades.some(
            (d) => d.id_hotel_tours_horarios === horarioId && d.fecha === fecha
        );
    };

    const esDiaNoDisponible = (
        fechaStr: string,
        horarioId: number,
        diasNoDisponibles: DiaDisponible[]
    ): boolean => {
        const fecha = new Date(fechaStr + "T00:00:00");

        const diaSemana = fecha.getDay(); // 0 (Domingo) - 6 (Sábado)

        return diasNoDisponibles.some((d) => {
            const inicio = new Date(d.fecha_inicio);
            const final = new Date(d.fecha_final);

            return (
                d.id_hotel_tours_horarios === horarioId &&
                d.dia === diaSemana &&
                fecha >= inicio &&
                fecha <= final
            );
        });
    };

    return (
        <ResponsiveModalAbsolute
            scrollRef={scrollRef}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            max_width={90}
        >
            <div className="flex flex-col items-center justify-center gap-2 p-2 mx-auto w-full relative  ">
                {modalCalendar && (
                    <div
                        ref={modalRef}
                        className="md:w-1/3 w-11/12 absolute flex flex-col lg:top-20 top-96 h-96 p-1 items-center bg-white justify-center gap-4 z-50"
                    >
                        <Calendar
                            onChange={onChangeCalendar}
                            minDate={new Date()}
                            tileDisabled={({ activeStartDate, date, view }) =>
                                calculateDisabledTiles(date)
                            }
                            value={
                                datesSelected
                                    ? datesSelected.fecha_inicial
                                    : undefined
                            }
                        />

                        <div
                            onClick={handleDeleteFechas}
                            className="underline cursor-pointer text-[#1C4CBB] justify-end w-full text-right px-5"
                        >
                            Borrar fechas
                        </div>
                    </div>
                )}

                <h2 className="2xl:text-4xl text-3xl text-[#1C4CBB] text-center font-medium">
                    Tour {tour?.nombre}
                </h2>
                <hr className="w-full bg-gray-300" />
                {loading ? (
                    <>
                        <Spinner />
                    </>
                ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center gap-4 lg:p-4 p-2 mx-auto ">
                        {tour && (
                            <div
                                key={`habitacion-${tour.id}`}
                                className={` w-full flex lg:flex-row flex-col justify-start lg:px-5 px-2 items-start gap-10`}
                            >
                                <div className="w-full lg:w-1/2 lg:sticky top-4 self-start h-fit">
                                    <Swiper
                                        key={tour.banner}
                                        modules={[Navigation, Lazy]}
                                        slidesPerView={1}
                                        watchSlidesProgress
                                        lazy={true}
                                        navigation
                                        rewind={true}
                                        loop={true}
                                    >
                                        <SwiperSlide
                                            key={tour.banner}
                                            className="cursor-pointer"
                                        >
                                            <img
                                                loading="lazy"
                                                className=" lg:h-[50vh] h-[30vh] rounded-md swiper-lazy mx-auto"
                                                alt="Imagen del producto"
                                                data-src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hoteles_tours/getImage/${tour.banner}`}
                                                data-srcset={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hoteles_tours/getImage/${tour.banner}`}
                                            />

                                            <div className="swiper-lazy-preloader">
                                                <div className="flex flex-col w-full lg:h-64 h-40  gap-2 p-3 bg-gray-200">
                                                    <div className="bg-slate-50 w-full h-[80%] rounded-xl"></div>
                                                    <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                    <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        {tour?.hotel_tour_imagenes?.map(
                                            (imagen) => (
                                                <SwiperSlide key={imagen.id}>
                                                    <img
                                                        loading="lazy"
                                                        className=" lg:h-[50vh] h-[30vh] rounded-md swiper-lazy mx-auto"
                                                        alt="Imagen del producto"
                                                        data-src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hoteles_tours/getImage/${imagen.imagen}`}
                                                        data-srcset={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hoteles_tours/getImage/${imagen.imagen}`}
                                                    />
                                                    <div className="swiper-lazy-preloader">
                                                        <div className="flex flex-col w-auto lg:h-[65vh] h-[30vh] gap-2 p-3 bg-gray-200">
                                                            <div className="bg-slate-50 w-full h-[80%] rounded-xl"></div>
                                                            <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                            <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        )}
                                    </Swiper>
                                </div>

                                <div className="lg:w-1/2 w-full flex flex-col items-center justify-center gap-4 ">
                                    <div className=" flex lg:flex-row flex-col 2xl:gap-10 gap-5  items-center justify-center   2xl:w-11/12 w-full mx-auto">
                                        <div className="flex flex-col justify-center items-center gap-2 2xl:w-2/5 w-1/5">
                                            <div className=" 2xl:text-lg text-base text-center text-[#1C4CBB] align-middle w-full  ">
                                                <p className="font-light select-none">
                                                    <span className="font-semibold">{`${SELECTED_CURRENCY} ${formatearNumero(
                                                        price_to_currency(
                                                            Number(
                                                                tour?.precio_base
                                                            )
                                                        )
                                                    )} `}</span>{" "}
                                                    /por persona
                                                </p>
                                            </div>

                                            <div className="flex items-center w-max gap-1.5">
                                                <div className="text-sm text-center md:text-base text-[#1C4CBB] ">
                                                    {tour.personas} Personas
                                                </div>
                                                <svg
                                                    className={`w-6 h-6 2xl:h-8 2xl:w-8 border border-[#1C4CBB] rounded-full`}
                                                    id="Capa_2"
                                                    data-name="Capa 2"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 62.33 62.33"
                                                >
                                                    <g id="Portada">
                                                        <g>
                                                            <circle
                                                                className="cls-1"
                                                                cx="31.17"
                                                                cy="31.17"
                                                                r="30.67"
                                                                fill="white"
                                                                fillOpacity="100"
                                                            />
                                                            <g>
                                                                <path
                                                                    fill="#1C4CBB"
                                                                    className="cls-2"
                                                                    d="m39.6,39.12c0,1.02,0,2.05,0,3.07,0,.34-.13.55-.43.71-2.07,1.09-4.27,1.75-6.61,1.95-3.3.28-6.39-.4-9.32-1.91-.35-.18-.52-.4-.51-.82.02-1.91,0-3.82.01-5.74.01-2.29,1.55-4.44,3.7-5.21.23-.08.39-.05.59.1,2.62,1.99,5.67,2,8.27,0,.23-.17.41-.18.66-.08,2.19.86,3.63,2.93,3.64,5.29,0,.88,0,1.75,0,2.63Z"
                                                                />
                                                                <path
                                                                    fill="#1C4CBB"
                                                                    className="cls-2"
                                                                    d="m50.43,36.04c0,.85,0,1.7,0,2.54,0,.32-.13.53-.41.67-1.79.94-3.68,1.49-5.7,1.64-1.14.09-2.25-.01-3.37-.17-.33-.05-.44-.18-.45-.52-.01-1.4.07-2.8-.05-4.2-.17-2.05-1.12-3.65-2.77-4.85-.4-.29-.4-.28-.05-.64.41-.42.88-.75,1.41-1,.2-.1.36-.09.55.07,2.13,1.9,5.43,1.87,7.49,0,.18-.16.34-.17.55-.06,1.75.88,2.71,2.29,2.78,4.26.03.75,0,1.51,0,2.26Z"
                                                                />
                                                                <path
                                                                    fill="#1C4CBB"
                                                                    className="cls-2"
                                                                    d="m11.91,35.81c.05-.84-.13-1.89.1-2.91.34-1.56,1.25-2.68,2.69-3.38.23-.11.39-.08.58.08,2.26,1.88,5.2,1.88,7.43,0,.21-.17.38-.2.61-.08.54.27,1,.62,1.43,1.04.23.23.23.36-.05.56-1.51,1.05-2.44,2.49-2.75,4.3-.14.8-.12,1.61-.12,2.42,0,.79-.01,1.59,0,2.38,0,.3-.1.43-.39.49-3.22.56-6.26.04-9.15-1.48-.27-.14-.38-.35-.38-.65,0-.86,0-1.72,0-2.78Z"
                                                                />
                                                                <path
                                                                    fill="#1C4CBB"
                                                                    className="cls-2"
                                                                    d="m25.49,26.17c0-3.16,2.55-5.7,5.71-5.69,3.15,0,5.67,2.56,5.66,5.74,0,3.12-2.57,5.69-5.69,5.68-3.14,0-5.68-2.57-5.68-5.73Z"
                                                                />
                                                                <path
                                                                    fill="#1C4CBB"
                                                                    className="cls-2"
                                                                    d="m48.16,25.31c0,2.66-2.17,4.83-4.84,4.83-2.62,0-4.81-2.21-4.81-4.83,0-2.63,2.21-4.84,4.85-4.83,2.64,0,4.8,2.18,4.8,4.83Z"
                                                                />
                                                                <path
                                                                    fill="#1C4CBB"
                                                                    className="cls-2"
                                                                    d="m14.18,25.3c0-2.66,2.18-4.83,4.84-4.83,2.62,0,4.81,2.21,4.81,4.83,0,2.64-2.21,4.83-4.86,4.83-2.64,0-4.8-2.18-4.8-4.83Z"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>

                                        <div className=" h-20  border-l-2 border-[#1C4CBB] hidden lg:flex"></div>

                                        <div className="2xl:py-5 py-3 px-5 shadow-lg border border-gray-200 rounded-lg flex flex-col justify-center items-center 2xl:w-3/5 w-4/5  ">
                                            <div className="text-xl text-center font-semibold text-[#029BFC]">
                                                {!reserveVisible &&
                                                    "Elije una fecha"}
                                            </div>
                                            <div className=" 2xl:w-5/6 w-11/12 mx-auto border-2 border-gray-500 rounded-lg  mt-4 relative ">
                                                <div className="flex divide-x-2 divide-gray-500  border-gray-500">
                                                    <div
                                                        onClick={() =>
                                                            setModalCalendar(
                                                                !modalCalendar
                                                            )
                                                        }
                                                        className="flex-1 2xl:p-4 p-3 cursor-pointer"
                                                    >
                                                        <p className="text-xs font-medium text-gray-800 uppercase">
                                                            Fecha
                                                        </p>
                                                        <p
                                                            className={`mt-1 text-sm font-semibold ${
                                                                dataReseve.fecha_inicial ===
                                                                "Selecciona una fecha"
                                                                    ? "text-gray-500"
                                                                    : "text-gray-800"
                                                            }`}
                                                        >
                                                            {
                                                                dataReseve.fecha_inicial
                                                            }
                                                        </p>
                                                    </div>

                                                    <div
                                                        onClick={() =>
                                                            handleModalHuespedes()
                                                        }
                                                        className="flex-1 2xl:p-4 p-3 cursor-pointer"
                                                    >
                                                        <div className="flex items-center justify-between">
                                                            <div>
                                                                <p className="text-xs font-medium text-gray-800 uppercase">
                                                                    HUÉSPEDES
                                                                </p>
                                                                <p className="mt-1 text-sm font-semibold text-gray-800">
                                                                    {
                                                                        dataReseve.huespedes
                                                                    }{" "}
                                                                    huésped
                                                                </p>
                                                            </div>
                                                            <div className="text-gray-500">
                                                                {modalHuespedes ? (
                                                                    <svg
                                                                        className="h-5 w-5 "
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        stroke="currentColor"
                                                                    >
                                                                        <path
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                            strokeWidth="2"
                                                                            d="M5 15l7-7 7 7"
                                                                        />
                                                                    </svg>
                                                                ) : (
                                                                    <svg
                                                                        className="h-5 w-5 "
                                                                        width="24"
                                                                        height="24"
                                                                        viewBox="0 0 24 24"
                                                                        strokeWidth="2"
                                                                        stroke="currentColor"
                                                                        fill="none"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        {" "}
                                                                        <path
                                                                            stroke="none"
                                                                            d="M0 0h24v24H0z"
                                                                        />{" "}
                                                                        <polyline points="6 9 12 15 18 9" />
                                                                    </svg>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {modalHuespedes && (
                                                    <ModalHuespedes
                                                        modalRefCalendar={
                                                            modalRefCalendar
                                                        }
                                                        huespedes={huespedes}
                                                        handleInputChange={
                                                            handleInputChange
                                                        }
                                                        handleInputClick={
                                                            handleInputClick
                                                        }
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-1 flex flex-col justify-center items-center gap-4 w-full ">
                                        {listadoFechas.map(
                                            (
                                                listadoFecha: ListadoFecha,
                                                index
                                            ) =>
                                                tour.horarios.length > 0
                                                    ? tour.horarios.map(
                                                          (horario) => {
                                                              // Buscar si hay un precio_variable que coincida con la fecha y el id del horario
                                                              const precioVariable =
                                                                  tour.precios_variables?.find(
                                                                      (p) =>
                                                                          p.id_hotel_tours_horarios ===
                                                                              horario.id &&
                                                                          p.fecha.toString() ===
                                                                              listadoFecha.fecha
                                                                  );

                                                              // Decidir cuál precio usar
                                                              const precioFinal =
                                                                  precioVariable
                                                                      ? precioVariable.precio
                                                                      : tour?.precio_base;

                                                              const noDisponiblePorFecha =
                                                                  esFechaNoDisponible(
                                                                      listadoFecha.fecha,
                                                                      horario.id,
                                                                      tour
                                                                          .disponibilidades
                                                                          ?.arrayFechas ||
                                                                          []
                                                                  );

                                                              const noDisponiblePorDia =
                                                                  esDiaNoDisponible(
                                                                      listadoFecha.fecha,
                                                                      horario.id,
                                                                      tour
                                                                          .disponibilidades
                                                                          ?.arrayDias ||
                                                                          []
                                                                  );

                                                              if (
                                                                  noDisponiblePorFecha ||
                                                                  noDisponiblePorDia
                                                              )
                                                                  return null;

                                                              return (
                                                                  <div
                                                                      key={
                                                                          index -
                                                                          horario.id
                                                                      }
                                                                      className="bg-gray-50 border border-gray-200 rounded-lg shadow-md p-5 flex justify-between items-start w-4/5 mx-auto hover:bg-blue-100 cursor-pointer"
                                                                  >
                                                                      <div className="flex flex-col items-start justify-start gap-4">
                                                                          <div className="text-base text-gray-800 capitalize  font-semibold">
                                                                              {
                                                                                  listadoFecha.nombre
                                                                              }
                                                                          </div>

                                                                          <div className="text-sm  text-gray-800">
                                                                              {agregarAMPM(
                                                                                  horario.hora_inicio
                                                                              )}{" "}
                                                                              -{" "}
                                                                              {agregarAMPM(
                                                                                  horario.hora_final
                                                                              )}
                                                                          </div>
                                                                      </div>
                                                                      <div className="flex flex-col items-start justify-start gap-2">
                                                                          <div className="text-base text-gray-800 capitalize  font-semibold underline">
                                                                              {`${SELECTED_CURRENCY} ${formatearNumero(
                                                                                  price_to_currency(
                                                                                      Number(
                                                                                          precioFinal
                                                                                      )
                                                                                  )
                                                                              )}`}{" "}
                                                                              por
                                                                              persona
                                                                          </div>

                                                                          <div
                                                                              onClick={() =>
                                                                                  handleSubmit(
                                                                                      horario,

                                                                                      String(
                                                                                          precioFinal
                                                                                      ),
                                                                                      listadoFecha.fecha
                                                                                  )
                                                                              }
                                                                              className="px-5 py-2 rounded-lg bg-[#029BFC] text-white font-bold text-center text-sm cursor-pointer hover:scale-105 transition-transform duration-300"
                                                                          >
                                                                              Reserva
                                                                          </div>
                                                                      </div>
                                                                  </div>
                                                              );
                                                          }
                                                      )
                                                    : null
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </ResponsiveModalAbsolute>
    );
};
